const LOADING_MSG = {
  ASSET: {
    CREATE_FOLDER: "Your folder is getting created...",
    MOVE_FOLDER: "Moving selected items...",
    DELETE_ITEM: "Deleting selected items...",
  },
  ADD_ITEM_QTABLE: "Adding products to quote table...",
  DELETE_ITEM_QTABLE: "Deleting products from quote table...",
  DOCUMENT: "🏃🏽‍♂️ Fetching your document...",
  DOCUMENTS: "Loading your documents...",
  DOCUMENT_DOWNLOADING: "Document download is in progress...",
  DOCUMENT_FOR_EDITING: "🏃🏽‍♂️ Fetching your document for editing...",
  FOLDER: "Loading your folder...",
  GLOBAL_TEMPLATE_PREVIEW: "Loading your preview...",
  ORG_TEMPLATE: "Loading template preview",
  INBOX: "Loading your inbox...",
  PIPELINE: "Loading your pipeline...",
  PRICEBOOK: "Loading your pricebook...",
  PRICEBOOKS: "Loading your pricebooks...",
  PRODUCTS: "Loading your products...",
  TEMPLATE: "Loading your template...",
  TEMPLATES: "Loading your templates...",
  WORKFLOW: "Loading your workflow...",
  WORKFLOWS: "Loading your workflows...",
};
export default LOADING_MSG;



// WEBPACK FOOTER //
// ./src/constants/loadingMsg.js